/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon24Solid = forwardRef('NetCloudWireIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17.081 4.806a6.6 6.6 0 0 0-12.46 1.528A6 6 0 0 0 6.6 18H11v3H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2h-5v-3h3.8a6.6 6.6 0 0 0 .281-13.194Z" })));
});
